const RoleAccessRuleLangKey = [
	'title_label_access',

	'any_name',
	'any_tooltip',

	'api_health_check_name',
	'api_health_check_tooltip',
	'api_postback_send_name',
	'api_postback_send_tooltip',

	'auth_login_name',
	'auth_login_tooltip',
	'auth_profile_name',
	'auth_profile_tooltip',

	'common_country_any_name',
	'common_country_any_tooltip',
	'common_country_list_name',
	'common_country_list_tooltip',
	'common_country_read_name',
	'common_country_read_tooltip',

	'common_language_any_name',
	'common_language_any_tooltip',
	'common_language_list_name',
	'common_language_list_tooltip',
	'common_language_read_name',
	'common_language_read_tooltip',

	'common_time_zone_any_name',
	'common_time_zone_any_tooltip',
	'common_time_zone_list_name',
	'common_time_zone_list_tooltip',
	'common_time_zone_read_name',
	'common_time_zone_read_tooltip',

	'role_any_name',
	'role_any_tooltip',
	'role_list_name',
	'role_list_tooltip',
	'role_read_name',
	'role_read_tooltip',
	'role_create_name',
	'role_create_tooltip',
	'role_modify_name',
	'role_modify_tooltip',
	'role_remove_name',
	'role_remove_tooltip',

	'account_any_name',
	'account_any_tooltip',
	'account_list_name',
	'account_list_tooltip',
	'account_is_fired_list_name',
	'account_is_fired_list_tooltip',
	'account_read_name',
	'account_read_tooltip',
	'account_create_name',
	'account_create_tooltip',
	'account_modify_name',
	'account_modify_tooltip',
	'account_remove_name',
	'account_remove_tooltip',
	'account_resurrect_name',
	'account_resurrect_tooltip',

	'account_buyer_any_name',
	'account_buyer_any_tooltip',
	'account_buyer_self_name',
	'account_buyer_self_tooltip',
	'account_buyer_list_name',
	'account_buyer_list_tooltip',

	'account_team_any_name',
	'account_team_any_tooltip',
	'account_team_self_name',
	'account_team_self_tooltip',
	'account_team_list_name',
	'account_team_list_tooltip',

	'affiliate_any_name',
	'affiliate_any_tooltip',
	'affiliate_list_name',
	'affiliate_list_tooltip',
	'affiliate_read_name',
	'affiliate_read_tooltip',
	'affiliate_create_name',
	'affiliate_create_tooltip',
	'affiliate_modify_name',
	'affiliate_modify_tooltip',
	'affiliate_remove_name',
	'affiliate_remove_tooltip',

	'offer_scope_any_name',
	'offer_scope_any_tooltip',
	'offer_scope_list_name',
	'offer_scope_list_tooltip',
	'offer_scope_read_name',
	'offer_scope_read_tooltip',
	'offer_scope_create_name',
	'offer_scope_create_tooltip',
	'offer_scope_modify_name',
	'offer_scope_modify_tooltip',
	'offer_scope_remove_name',
	'offer_scope_remove_tooltip',

	'offer_any_name',
	'offer_any_tooltip',
	'offer_any_group_name',
	'offer_any_group_tooltip',
	'offer_list_name',
	'offer_list_tooltip',
	'offer_read_name',
	'offer_read_tooltip',
	'offer_create_name',
	'offer_create_tooltip',
	'offer_modify_name',
	'offer_modify_tooltip',
	'offer_remove_name',
	'offer_remove_tooltip',
	'offer_resurrect_name',
	'offer_resurrect_tooltip',
	'offer_bind_name',
	'offer_bind_tooltip',
	'offer_unbind_name',
	'offer_unbind_tooltip',

	'offer_spend_any_name',
	'offer_spend_any_tooltip',
	'offer_spend_any_account_name',
	'offer_spend_any_account_tooltip',
	'offer_spend_any_day_name',
	'offer_spend_any_day_tooltip',
	'offer_spend_any_group_name',
	'offer_spend_any_group_tooltip',
	'offer_spend_list_name',
	'offer_spend_list_tooltip',
	'offer_spend_read_name',
	'offer_spend_read_tooltip',
	'offer_spend_create_name',
	'offer_spend_create_tooltip',
	'offer_spend_modify_name',
	'offer_spend_modify_tooltip',
	'offer_spend_remove_name',
	'offer_spend_remove_tooltip',

	'offer_spend_by_any_name',
	'offer_spend_by_any_tooltip',
	'offer_spend_by_account_list_name',
	'offer_spend_by_account_list_tooltip',
	'offer_spend_by_offer_list_name',
	'offer_spend_by_offer_list_tooltip',
	'offer_spend_by_offer_scope_list_name',
	'offer_spend_by_offer_scope_list_tooltip',

	'revenue_any_name',
	'revenue_any_tooltip',
	'revenue_list_name',
	'revenue_list_tooltip',
	'revenue_read_name',
	'revenue_read_tooltip',
	'revenue_create_name',
	'revenue_create_tooltip',
	'revenue_modify_name',
	'revenue_modify_tooltip',
	'revenue_remove_name',
	'revenue_remove_tooltip',

	'revenue_agency_any_name',
	'revenue_agency_any_tooltip',
	'revenue_agency_list_name',
	'revenue_agency_list_tooltip',
	'revenue_agency_read_name',
	'revenue_agency_read_tooltip',
	'revenue_agency_create_name',
	'revenue_agency_create_tooltip',
	'revenue_agency_modify_name',
	'revenue_agency_modify_tooltip',
	'revenue_agency_remove_name',
	'revenue_agency_remove_tooltip',

	'revenue_spend_any_name',
	'revenue_spend_any_tooltip',
	'revenue_spend_list_name',
	'revenue_spend_list_tooltip',
	'revenue_spend_read_name',
	'revenue_spend_read_tooltip',
	'revenue_spend_create_name',
	'revenue_spend_create_tooltip',
	'revenue_spend_modify_name',
	'revenue_spend_modify_tooltip',
	'revenue_spend_remove_name',
	'revenue_spend_remove_tooltip',

	'revenue_spend_by_any_name',
	'revenue_spend_by_any_tooltip',
	'revenue_spend_by_account_list_name',
	'revenue_spend_by_account_list_tooltip',
	'revenue_spend_by_accounts_list_name',
	'revenue_spend_by_accounts_list_tooltip',
	'revenue_spend_by_team_list_name',
	'revenue_spend_by_team_list_tooltip',
	'revenue_spend_by_teams_list_name',
	'revenue_spend_by_teams_list_tooltip',

	'debug_any_name',
	'debug_any_tooltip',
	'debug_cron_runner_name',
	'debug_cron_runner_tooltip',
	'debug_draft_name',
	'debug_draft_tooltip',
	'debug_message_name',
	'debug_message_tooltip',

	'job_any_name',
	'job_any_tooltip',
	'job_list_name',
	'job_list_tooltip',
	'job_read_name',
	'job_read_tooltip',
	'job_create_name',
	'job_create_tooltip',
	'job_modify_name',
	'job_modify_tooltip',
	'job_remove_name',
	'job_remove_tooltip',

	'project_any_name',
	'project_any_tooltip',
	'project_list_name',
	'project_list_tooltip',
	'project_read_name',
	'project_read_tooltip',
	'project_create_name',
	'project_create_tooltip',
	'project_modify_name',
	'project_modify_tooltip',
	'project_remove_name',
	'project_remove_tooltip'
] as const

type IRoleAccessRuleLangKey = typeof RoleAccessRuleLangKey[number]

export type IRoleAccessRuleLang = {
	role_access_rule: Record<IRoleAccessRuleLangKey, string>
}

const langEntries = RoleAccessRuleLangKey.map(
	(key: IRoleAccessRuleLangKey) => [key, `role_access_rule.${key}`]
)

const langObj: Record<IRoleAccessRuleLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_ACCESS_RULE_LANG_KEY: IRoleAccessRuleLang = {
	role_access_rule: langObj
}
